export default __webpack_public_path__ + "static/media/avatar-bts-jimin.8c5ad5cf.png";